// Shared
import base from './shared/base.js';
import event from './shared/event.js';

// Pages
import billingInfo from './screen/billingInfo.js';
import paymentDetails from './screen/paymentDetails.js';
import companyInfo from './screen/companyInfo.js';
import crossPop from './screen/crossPop.js';
import reviewPage from './screen/reviewPage.js';
import thankYouPage from './screen/thankYouPage.js';
import invoicePage from './screen/invoicePage.js';
import errorPage from './screen/errorPage.js';

// Events
import cartView from './event/cartView.js';
import purchase from './event/purchase.js';

export default {
	base,
	event,
	cartView,
	purchase,
	billingInfo,
	paymentDetails,
	companyInfo,
	crossPop,
	reviewPage,
	thankYouPage,
	invoicePage,
	errorPage
};
